import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty as _isEmpty } from 'lodash';
import { DeviceBase } from './pgh-user-device';



export function buildDeviceDisplayName(device?: DeviceBase): string | undefined {
  if (device == null) {
    return undefined;
  }

  if (device.displayName != null && !_isEmpty(device.displayName.trim())) {
    return device.displayName.trim();
  }

  return `${(device?.make ?? '').trim()} ${(device?.model ?? '').trim()}`.trim();
}

@Pipe({
  name: 'deviceDisplayName'
})
export class DeviceDisplayNamePipe implements PipeTransform {

  public transform(value?: DeviceBase, ...args: unknown[]): string | undefined {
    return buildDeviceDisplayName(value);
  }

}
